import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import './assets/css/index.css';

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(new URL('service-worker.js', import.meta.url)).then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      }).catch(error => {
        console.error('Service Worker registration failed:', error);
      });
    });
  }
  

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App/>
);
